import type { Culture } from '@creanizer/types'

interface WorldCulturesProps {
  cultures: Culture[]
}

export function WorldCultures({ cultures }: WorldCulturesProps) {
  return (
    <div className="space-y-4">
      {cultures.map((culture, index) => (
        <div key={index} className="p-4 border rounded-lg space-y-3">
          <div>
            <h3 className="font-semibold text-lg">{culture.name}</h3>
            <p className="text-sm text-muted-foreground mt-1">{culture.description}</p>
          </div>
          
          <div className="grid grid-cols-2 gap-2 text-sm">
            {culture.population && (
              <div>
                <span className="font-medium">人口: </span>
                <span className="text-muted-foreground">{culture.population}</span>
              </div>
            )}
            {culture.language && (
              <div>
                <span className="font-medium">言語: </span>
                <span className="text-muted-foreground">{culture.language}</span>
              </div>
            )}
            {culture.governance && (
              <div>
                <span className="font-medium">統治: </span>
                <span className="text-muted-foreground">{culture.governance}</span>
              </div>
            )}
            {culture.architecture && (
              <div>
                <span className="font-medium">建築: </span>
                <span className="text-muted-foreground">{culture.architecture}</span>
              </div>
            )}
            {culture.clothing && (
              <div className="col-span-2">
                <span className="font-medium">服装: </span>
                <span className="text-muted-foreground">{culture.clothing}</span>
              </div>
            )}
          </div>
          
          {culture.values && culture.values.length > 0 && (
            <div>
              <h4 className="text-sm font-semibold mb-1">価値観</h4>
              <div className="flex flex-wrap gap-1">
                {culture.values.map((value, idx) => (
                  <span
                    key={idx}
                    className="px-2 py-1 text-xs bg-blue-100 text-blue-700 rounded"
                  >
                    {value}
                  </span>
                ))}
              </div>
            </div>
          )}
          
          {culture.customs && culture.customs.length > 0 && (
            <div>
              <h4 className="text-sm font-semibold mb-1">習慣</h4>
              <ul className="list-disc list-inside text-sm text-muted-foreground">
                {culture.customs.map((custom, idx) => (
                  <li key={idx}>{custom}</li>
                ))}
              </ul>
            </div>
          )}
          
          {culture.taboos && culture.taboos.length > 0 && (
            <div>
              <h4 className="text-sm font-semibold mb-1">タブー</h4>
              <ul className="list-disc list-inside text-sm text-red-600">
                {culture.taboos.map((taboo, idx) => (
                  <li key={idx}>{taboo}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      ))}
    </div>
  )
}